export default {
  name: 'custom_tel_field',
  component_path: 'modules/procedures/blocks/BlockInputTel'
}